import React from 'react'
import PropTypes from 'prop-types'
import {Tooltip} from 'reactstrap'
import styles from './EditorTooltip.scss'

class EditorTooltipContainer extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    this.state = {tooltipIsFocused: false}
  }

  tooltipIsOpen = () => {
    // ensure either this editor is focused or we are hovering above the tooltip
    const isOpen = this.props.isOpen &&
      (this.props.state.isFocused || this.state.tooltipIsFocused)
    return isOpen
  }

  onEnterTooltip = () => {
    this.setState({tooltipIsFocused: true})
  }

  onLeaveTooltip = () => {
    this.setState({tooltipIsFocused: false})
  }

  getTetherRef = tetherRef => {
    if (tetherRef) {
      this.removeTooltipEventListeners()
      tetherRef.element.addEventListener('mouseenter', this.onEnterTooltip)
      tetherRef.element.addEventListener('mouseleave', this.onLeaveTooltip)
      this.tetherRef = tetherRef
    }
  }

  removeTooltipEventListeners = () => {
    if (this.tetherRef && this.tetherRef.element) {
      this.tetherRef.element.removeEventListener('mouseenter', this.onEnterTooltip)
      this.tetherRef.element.removeEventListener('mouseout', this.onLeaveTooltip)
    }
  }

  componentWillUnmount = () => {
    this.removeTooltipEventListeners()
  }

  render () {
    if (process.env.NODE_ENV === 'test') { return null }

    const isOpen = this.tooltipIsOpen()

    const methods = {
      tetherRef: this.getTetherRef
    }

    return <Tooltip
      toggle={this.props.toggle}
      target={this.props.target}
      delay={this.props.delay}
      className={this.props.className || styles.EditorTooltip}
      autohide={this.props.autohide || false}
      placement={this.props.placement}
      {...methods} isOpen={isOpen} >
      {this.props.children}
    </Tooltip>
  }
}

EditorTooltipContainer.propTypes = {
  children: PropTypes.element,
  // slate editor state
  state: PropTypes.object.isRequired,
  // boolean to control the state of the tooltip
  isOpen: PropTypes.bool,
  // callback for toggling isOpen in the controlling component
  toggle: PropTypes.func,
  // target element or element ID, popover is attached to this element
  target: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.element
  ]).isRequired,
  // optionally override show/hide delays - default { show: 0, hide: 250 }
  delay: PropTypes.oneOfType([
    PropTypes.shape({ show: PropTypes.number, hide: PropTypes.number }),
    PropTypes.number
  ]),
  className: PropTypes.string,
  // optionally hide tooltip when hovering over tooltip content - default true
  autohide: PropTypes.bool,
  // convenience attachments for popover
  placement: PropTypes.oneOf([
    'auto',
    'auto-start',
    'auto-end',
    'top',
    'top-start',
    'top-end',
    'right',
    'right-start',
    'right-end',
    'bottom',
    'bottom-start',
    'bottom-end',
    'left',
    'left-start',
    'left-end'
  ])
}

export default EditorTooltipContainer



// WEBPACK FOOTER //
// ./src/components/EditorTooltip/EditorTooltipContainer.js